import { render, staticRenderFns } from "./ServiceDetail.vue?vue&type=template&id=6dd45604&scoped=true&"
import script from "./ServiceDetail.vue?vue&type=script&lang=js&"
export * from "./ServiceDetail.vue?vue&type=script&lang=js&"
import style0 from "./ServiceDetail.vue?vue&type=style&index=0&id=6dd45604&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6dd45604",
  null
  
)

export default component.exports